import styled, { css } from 'styled-components';
import { Icon } from '../icon/index.js';
import { getTypographyStyles, SYS_SIZE_FIXED_50, SYS_SPACE_FIXED_50, getMargins, SYS_SPACE_FIXED_100, SYS_TYPOGRAPHY_LINK_ORDER3_BOLD, SYS_TYPOGRAPHY_LINK_ORDER2_BOLD, SYS_TYPOGRAPHY_LINK_ORDER1_BOLD, SYS_TYPOGRAPHY_LINK_ORDER1_NORMAL, SYS_TYPOGRAPHY_LINK_ORDER2_NORMAL, SYS_TYPOGRAPHY_LINK_ORDER3_NORMAL, SYS_SIZE_FIXED_600, CMP_SIZE_NAVIGATION_STANDALONE_TEXT_LINK_UNDERLINE_THICKNESS, CMP_SPACE_NAVIGATION_STANDALONE_TEXT_LINK_UNDERLINE_OFFSET } from '@oneaudi/unified-web-alpha-common';
export const StyledTextLink = styled.a `
  // TODO: get motion tokens
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: color, text-decoration-color;
  margin: ${(props) => getMargins(props.margin)};
  display: ${(props) => props.variant === 'inline' && !props.icon
    ? 'inline-block'
    : 'inline-flex'}; // If standalone variant or icon present, then inline-flex
  align-items: center;

  ${(props) => {
    if (props.variant === 'inline' && props.weight === 'bold') {
        return getTypographyStyles(props.size === 'md'
            ? SYS_TYPOGRAPHY_LINK_ORDER1_BOLD
            : props.size === 'sm'
                ? SYS_TYPOGRAPHY_LINK_ORDER2_BOLD
                : SYS_TYPOGRAPHY_LINK_ORDER3_BOLD);
    }
    else if (props.variant === 'inline' && props.weight === 'normal') {
        return getTypographyStyles(props.size === 'md'
            ? SYS_TYPOGRAPHY_LINK_ORDER1_NORMAL
            : props.size === 'sm'
                ? SYS_TYPOGRAPHY_LINK_ORDER2_NORMAL
                : SYS_TYPOGRAPHY_LINK_ORDER3_NORMAL);
    }
    return getTypographyStyles(props.size === 'md'
        ? SYS_TYPOGRAPHY_LINK_ORDER1_NORMAL
        : SYS_TYPOGRAPHY_LINK_ORDER2_NORMAL);
}};

  color: ${(props) => props.theme.cmp.color.navigation.textLink.foreground.default};
  text-decoration-line: underline;
  text-decoration-color: ${(props) => props.theme.cmp.color.navigation.textLink.foreground.default};

  &:hover:not(:disabled),
  &:active:not(:disabled) {
    color: ${(props) => props.theme.cmp.color.navigation.textLink.foreground.interactive};
    text-decoration-color: ${(props) => props.theme.cmp.color.navigation.textLink.foreground.interactive};
  }

  &:disabled {
    cursor: not-allowed;
    color: ${(props) => props.theme.cmp.color.navigation.textLink.foreground.disabled};
    text-decoration-color: ${(props) => props.theme.cmp.color.navigation.textLink.foreground.disabled};
  }

  ${(props) => props.variant === 'inline' &&
    css `
      text-decoration-thickness: auto;
      text-decoration-skip-ink: none;
      text-underline-offset: auto;
    `}

  ${(props) => props.variant === 'standalone' &&
    props.underline &&
    css `
      box-sizing: border-box;
      text-decoration-thickness: ${CMP_SIZE_NAVIGATION_STANDALONE_TEXT_LINK_UNDERLINE_THICKNESS};
      text-underline-offset: ${CMP_SPACE_NAVIGATION_STANDALONE_TEXT_LINK_UNDERLINE_OFFSET};
      padding-bottom: ${SYS_SIZE_FIXED_50};
      min-height: ${SYS_SIZE_FIXED_600};
    `}

      ${(props) => props.variant === 'standalone' &&
    !props.underline &&
    css `
      text-decoration: none;
    `}

  ${(props) => props.as === 'button' &&
    css `
      cursor: pointer;
      background: transparent;
      border: none;
      padding: 0;
      text-align: left;
      ${props.variant === 'standalone' &&
        props.underline &&
        css `
        padding-bottom: ${SYS_SIZE_FIXED_50};
      `}
    `}
`;
export const StyledIcon = styled(Icon) `
  flex-shrink: 0;
  ${(props) => props.variant === 'standalone' &&
    props.iconPosition === 'leading' &&
    css `
      margin-right: ${SYS_SPACE_FIXED_100};
    `}

  ${(props) => props.variant === 'standalone' &&
    props.iconPosition === 'trailing' &&
    css `
      margin-left: ${SYS_SPACE_FIXED_100};
    `}

  ${(props) => props.variant === 'inline' &&
    css `
      margin-left: ${SYS_SPACE_FIXED_50};
    `}
`;
//# sourceMappingURL=index.styles.js.map